export default {"src":"/_next/static/media/pauseIcon.dcb7f141.svg","height":29,"width":20};